import React from "react";
import { renderContent } from "../../utilities/renderContent";

function FaqAnswer({ answer }) {
  return <div className="pr-10 lg:pr-12 break-words" dangerouslySetInnerHTML={renderContent(answer)} />;
}

export default FaqAnswer;
